import {
  announcementItems,
  announcementCreate,
  announcementDelete,
  announcementUpdate
} from '@/api/announcement'

const announcement = {
  state: {

  },
  mutations: {

  },
  actions: {
    AnnouncementItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnouncementCreate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementCreate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnouncementDelete ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementDelete(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnouncementUpdate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementUpdate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default announcement



// WEBPACK FOOTER //
// ./src/store/modules/announcement.js